<template>
  <b-card>
    <b-row>
      <b-col>
        <title-name />
      </b-col>
      <b-col>
        <feature-groups/>
      </b-col>
      <b-col>
        <renk />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard,BRow,BCol } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Features/elements/Title.vue'
import FeatureGroups from "@/views/Admin/Defines/Features/elements/Feature_group.vue"
import Renk from "@/views/Admin/Defines/Features/elements/Renk.vue"

export default {
  name: 'FeatureForm',
  components: {
    FeatureGroups,
    BCard,
    BRow,
    BCol,
    TitleName,
    Renk,
  },
}
</script>
